<custom-switch-button [switchOptions]="units" (switchClicked)="onUnitSwitchClicked($event)">
</custom-switch-button>